import { render, staticRenderFns } from "./EventCompanyProfile.vue?vue&type=template&id=206514fc"
import script from "./EventCompanyProfile.vue?vue&type=script&lang=js"
export * from "./EventCompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./EventCompanyProfile.vue?vue&type=style&index=0&id=206514fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports